import React, { useState, useEffect } from 'react';
import RewardDashboard from './../../presentation/rewardDashboard/RewardDashboard.jsx';
import { Message } from 'antd';
import { REVERSE_MAPING_BADGE_TYPE } from 'src/RnRCommonComponent/CoreBadge/rewardsConstants.js';

const RewardDashboardContainer = (props) => {
	const { isSharingVisible, currentUser, badgeList, isLoading, error } = props;
	const [rewardModalData, setRewardModalData] = useState();
	const [isRewardModalOpen, setIsRewardModaOpen] = useState(false);

	const getRewardDetail = (badgeAssignment) => {
		setIsRewardModaOpen(true);
		setRewardModalData(badgeAssignment);
		setIsRewardModaOpen(false);
	};

	const rewardListData =
		badgeList
			?.filter((badge) => badge.badgeId)
			.map((badge) => {
				const badgeTypeCode =
					REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || badge.badgeType?.code;

				return {
					...badge,
					badgeTypeCode: badgeTypeCode,
					iconCode: badge.iconInfo?.code || badge.iconInfo?.icon,
					badgeType: badgeTypeCode,
					badgeIcon: badge.iconInfo?.code || badge.iconInfo?.icon,
				};
			}) || [];

	useEffect(() => {
		if (error) {
			Message.error('Failed to fetch reward list');
		}
	}, [error]);

	return (
		<div>
			<RewardDashboard
				isLoading={isLoading}
				rewardsListData={rewardListData}
				getRewardDetail={getRewardDetail}
				rewardModalData={rewardModalData}
				isRewardModalOpen={isRewardModalOpen}
				isSharingVisible={isSharingVisible}
				currentUser={currentUser}
			/>
		</div>
	);
};

export default RewardDashboardContainer;
